import React, { useState } from "react";
import "./BankAccountSettings.css";

export default function BankAccountSettings() {
  const [formData, setFormData] = useState({
    bankAccountTitle: "",
    bankName: "",
    bankAddress: "",
    companyAddress: "",
    sortCode: "",
    accountNumber: "",
    swiftCode: "",
    iban: "",
    paymentMethodCurrency: "",
    currencyPrice: "",
    currencyPriceRe: "",
    currencyWithdrawPrice: "",
    baseCurrencyName: "",
    baseCurrencyPrice: "",
    baseCurrencyPriceRe: "",
    baseCurrencyWithdrawPrice: "",
    showCurrencyConverter: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data Submitted:", formData);
    alert("Bank Account Settings Updated!");
  };

  return (
    <div className="bank-page">
      {/* Page Header */}
      <div className="page-header">
        <h2>Bank Account Settings</h2>
        <div className="breadcrumb">
          <a href="/">Home</a> / <a href="/app-settings">App Settings</a> / Bank Account Settings
        </div>
      </div>

      {/* Card */}
      <div className="card">
        <h3>Update Bank Account</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-field">
              <label>Bank Account Title</label>
              <input type="text" name="bankAccountTitle"
                value={formData.bankAccountTitle} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Bank Name</label>
              <input type="text" name="bankName"
                value={formData.bankName} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Bank Address</label>
              <input type="text" name="bankAddress"
                value={formData.bankAddress} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Company Address</label>
              <input type="text" name="companyAddress"
                value={formData.companyAddress} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Sort Code</label>
              <input type="text" name="sortCode"
                value={formData.sortCode} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Account Number</label>
              <input type="text" name="accountNumber"
                value={formData.accountNumber} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Swift Code</label>
              <input type="text" name="swiftCode"
                value={formData.swiftCode} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>IBAN</label>
              <input type="text" name="iban"
                value={formData.iban} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Payment Method Currency Name</label>
              <input type="text" name="paymentMethodCurrency"
                value={formData.paymentMethodCurrency} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Currency Price</label>
              <input type="text" name="currencyPrice"
                value={formData.currencyPrice} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Currency Price (Re Confirm)</label>
              <input type="text" name="currencyPriceRe"
                value={formData.currencyPriceRe} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Currency Withdraw Price</label>
              <input type="text" name="currencyWithdrawPrice"
                value={formData.currencyWithdrawPrice} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Base Currency Name (USD)</label>
              <input type="text" name="baseCurrencyName"
                value={formData.baseCurrencyName} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Base Currency Price</label>
              <input type="text" name="baseCurrencyPrice"
                value={formData.baseCurrencyPrice} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Base Currency Price (Re Confirm)</label>
              <input type="text" name="baseCurrencyPriceRe"
                value={formData.baseCurrencyPriceRe} onChange={handleChange} />
            </div>

            <div className="form-field">
              <label>Base Currency Withdraw Price</label>
              <input type="text" name="baseCurrencyWithdrawPrice"
                value={formData.baseCurrencyWithdrawPrice} onChange={handleChange} />
            </div>
          </div>

          {/* Checkbox */}
          <div className="checkbox-group">
            <input type="checkbox" name="showCurrencyConverter"
              checked={formData.showCurrencyConverter} onChange={handleChange} />
            <label>Show Currency Converter on Client (Deposit/Withdraw) Page</label>
          </div>

          <div className="form-actions">
            <button type="submit" className="update-btn">Update</button>
          </div>
        </form>
      </div>

      {/* Footer */}
      <div className="footer">
        <p>
          Copyright © 2025 <span>Ample Markets</span>. All rights reserved.
        </p>
        <p className="version">Version 2.0</p>
      </div>
    </div>
  );
}

